// Add submit listener to all product forms
document.addEventListener('DOMContentLoaded', () => {
    const $forms = document.querySelectorAll('.AddToCartForm');
    if (!$forms) return;

    $forms.forEach($form => {
        $form.addEventListener('submit', (event) => {
            event.preventDefault();
            // Get basic input values
            const $idProduct = $form.querySelector('[name="id"]').value;
            const qty = $form.querySelector('[name="quantity"]') ? $form.querySelector('[name="quantity"]').value : 1;
            let selling_plan = "";

            let toggle = $form.querySelector('#toggle-btn')

            // Get skio widget
            const skioWidget = $form.querySelector('.skio-widget-hide');

            if (toggle) {
                if (toggle.checked)
                    selling_plan = 5062754540;//skioWidget.querySelector('[name="selling_plan"]').value; // This value is empty????
            }

            Shopify.theme.jsAjaxCart.customAddToCart($idProduct, selling_plan, qty);
        });
    });
});
